import { Clock, useIntl, type UserRequirement } from '@capsicum/common';
import { GenericDrawer, ModalService } from '@capsicum/common-web';
import { useUkCooldown } from '@capsicum/features/regulations/shared';
import { useEffect } from 'react';
import styled from 'styled-components';

export type UkCooldownProps = {
	isForcedRequirement?: boolean;
	onDismiss: () => void;
	requirement: UserRequirement;
};

export const UkCooldown = ({ isForcedRequirement, onDismiss, requirement }: UkCooldownProps) => {
	const { $t } = useIntl();

	const { message } = useUkCooldown(requirement);

	useEffect(() => {
		ModalService.addModal({
			detached: true,
			isClosable: !isForcedRequirement,
			onDismiss,
			renderComponent: ({ close }) => (
				<GenericDrawer
					buttonText={!isForcedRequirement ? $t('global.close') : undefined}
					description={message}
					image={Clock}
					testID="uk-cooldown-modal"
					onButtonPress={close}
				/>
			)
		});
	}, [message, onDismiss]);

	return <S.EmptyContainer />;
};

namespace S {
	export const EmptyContainer = styled.div`
		flex: 1;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
	`;
}
